import NewAppNoticeComponent from './new-app-notice.component'

export default NewAppNoticeComponent
